import { render, staticRenderFns } from "./HistoricOrderModal.vue?vue&type=template&id=3c08cac5&"
import script from "./HistoricOrderModal.vue?vue&type=script&lang=js&"
export * from "./HistoricOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports